import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IPortador } from '@app/modules/portador/model/portador.model';
import { PortadorService } from '@app/modules/portador/services/portador.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
  SELECT
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { Dialog } from 'primeng/dialog';
import { filter } from 'rxjs/operators';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';

@Component({
  selector: 'app-fast-portador',
  templateUrl: './fast-portador.component.html',
  styleUrls: ['./fast-portador.component.scss'],
  providers: [PortadorService]
})
export class FastPortadorComponent implements OnInit, AfterViewInit {
  @ViewChild('fastPortador') fastPortador: Dialog;
  form: UntypedFormGroup;

  loading = false;
  defaultExists = false;

  tipoPortador = [
    { viewValue: 'Interno', value: 'INTERNO' },
    { viewValue: 'Externo', value: 'EXTERNO' }
  ] as SELECT[];

  constructor(
    protected fb: UntypedFormBuilder,
    protected entityService: PortadorService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    protected dialogRef: MatDialogRef<FastPortadorComponent>,
    protected tokenService: TokenService
  ) {}

  ngAfterViewInit(): void {
    this.fastPortador.maximize();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ],
      padrao: [false, [Validators.required]],
      tipo: [this.tipoPortador[0], [Validators.required]],
      codigo_banco: [],
      saldo: [0],
      saldo_inicial: [
        0,
        [
          Validators.required,
          // CustomValidators.validateEqualsMinZero(),
          CustomValidators.validateCurrencyValues(15, 2),
          CustomValidators.existSpecialChar(true)
        ]
      ],
      nome_banco: [
        '',
        [Validators.maxLength(100), CustomValidators.isEmptyValue()]
      ],
      numero_conta: [
        '',
        [Validators.maxLength(20), CustomValidators.existSpecialChar()]
      ],
      digito_conta: ['', [CustomValidators.existSpecialChar()]],
      codigo_agencia: [
        '',
        [Validators.maxLength(20), CustomValidators.existSpecialChar()]
      ],
      digito_agencia: ['', [CustomValidators.existSpecialChar()]]
    });
    this.checkPortadorPadrao();
  }

  onSubmit() {
    this.loading = true;
    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    };
    entity.tipo = this.form.value.tipo.value;
    entity.saldo_inicial = Utils.replaceCommaToDot(
      this.form.value.saldo_inicial
    );
    entity.saldo = Utils.replaceCommaToDot(this.form.value.saldo);
    entity = Utils.trimAttributes(entity);

    if (this.form.valid) {
      this.entityService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          formPgmt => {
            this.loading = false;
            this.dialogRef.close(formPgmt);
            this.matSnackBar.open('Portador cadastrado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
          },
          (err: HttpErrorResponse) => {
            this.displayError(err);
            this.loading = false;
          }
        );
    }
  }

  validateForm() {
    this.form.markAllAsTouched();
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`.-]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  validateNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`.,]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  checkPortadorPadrao() {
    this.entityService
      .getEntitiesByParams(
        `domain_id=${
          this.tokenService.getDomain().id
        }&padrao=true&list_options=ACTIVE_ONLY`
      )
      .subscribe(
        (exists: IPortador[]) => {
          if (exists.length) this.defaultExists = true;
          else this.defaultExists = false;
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'descricao',
      this.tokenService.getDomain().id,
      null,
      this.form
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
